<template>
  <div id="products">
    <div v-show="loader" class="products_view_loader">
          <v-progress-circular class="loader__color" indeterminate size="54"></v-progress-circular>
    </div>
    <div class="products_view_main">
      <div class="promotions" 
          v-for="promotion in promotions"
          :key="promotion.id"
          :v-if="!promotions.length == 0"
      >
          <div class="products__name">
              <div class="products__name__line">

              </div>
              <div class="products__name__title">
                  <h2>
                      {{promotion.stock}}
                  </h2>
              </div>
          </div>
          <v-sheet
            class="mx-auto"
            elevation="8"
          >
            <v-slide-group
              v-model="model"
              class="pa-4"
              :prev-icon="prevIcon ? 'mdi-minus' : undefined"
              :next-icon="nextIcon ? 'mdi-plus' : undefined"
              :multiple="multiple"
              :mandatory="mandatory"
              :show-arrows="showArrows"
            >
              <v-slide-item
                v-for="stock_data_id in promotion.stock_data"
                :key="stock_data_id.id"
              >
                <v-card
                  class="ma-4"
                >
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center"
                  >   
                      <ProductBlock 
                        v-bind:id="stock_data_id.id" 
                        v-bind:img="stock_data_id.img[0]" 
                        v-bind:title="stock_data_id.title" 
                        v-bind:price="stock_data_id.price"
                        v-bind:stock_price="stock_data_id.stock_price" 
                        v-bind:description="stock_data_id.description" 
                        v-bind:remain="stock_data_id.remain" 
                        @addToCart="addToCart"
                        @addToFavorite="addToFavorite"
                      />
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
      </div>
      <div class="newproduct" v-if="!newproducts.length == 0">
          <div class="products__name">
              <div class="products__name__line">

              </div>
              <div class="products__name__title">
                  <h2>
                      Новинки
                  </h2>
              </div>
          </div>
          <v-sheet
            class="mx-auto"
            elevation="8"
          >
            <v-slide-group
              v-model="model"
              class="pa-4"
              :prev-icon="prevIcon ? 'mdi-minus' : undefined"
              :next-icon="nextIcon ? 'mdi-plus' : undefined"
              :multiple="multiple"
              :mandatory="mandatory"
              :show-arrows="showArrows"
            >
              <v-slide-item
                v-for="newproduct in newproducts"
                :key="newproduct.id"
              >
                <v-card
                  class="ma-4"
                >
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center"
                  >   
                      <ProductBlock 
                        v-bind:id="newproduct.id" 
                        v-bind:img="newproduct.img[0]" 
                        v-bind:title="newproduct.title" 
                        v-bind:price="newproduct.price"
                        v-bind:remain="newproduct.remain" 
                        v-bind:description="newproduct.description" 
                        @addToCart="addToCart"
                        @addToFavorite="addToFavorite"
                      />
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
      </div>
      <div class="hit" v-if="!hitproducts.length == 0">
        <div class="products__name">
              <div class="products__name__line">

              </div>
              <div class="products__name__title">
                  <h2>
                      Хиты продаж
                  </h2>
              </div>
          </div>
          <div class="hit__vuew__block">
              <div class="hit__vuew__block__margin"> 
                    <div 
                      class="hit__vuew__block__view" 
                      v-for="hitproduct in hitproducts"
                      :key="hitproduct.id"
                    >
                        <ProductBlock 
                          v-bind:id="hitproduct.id" 
                          v-bind:img="hitproduct.img[0]" 
                          v-bind:title="hitproduct.title" 
                          v-bind:price="hitproduct.price"
                          v-bind:remain="hitproduct.remain" 
                          v-bind:description="hitproduct.description" 
                          @addToCart="addToCart"
                          @addToFavorite="addToFavorite"
                        />
                  </div>
                  <div class="load_hit_btn">
                      <span v-show="!loadProducts" @click="initialLimitNextProducts">Показать еще</span>
                      <v-progress-circular v-show="loadProducts" class="loader__color" indeterminate size="34"></v-progress-circular>
                  </div>
              </div>
          </div>        
      </div>
    </div>
  </div>
</template>

<script>
  import ProductBlock from '@/components/ProductBlock'
  import {mapActions} from 'vuex'

  export default {
    data: () => ({
      model: null,
      multiple: false,
      mandatory: false,
      showArrows: true,
      prevIcon: false,
      nextIcon: false,
      centerActive: false,
      promotions: [],
      newproducts: [],
      hitproducts: [],
      loader: true,
      initialLimitPrev: 1,
      initialLimitNext: 12,
      loadProducts: false,
    }),
    components: {
      ProductBlock
    },
    methods: {
        getPromotions() {
            fetch(this.$apiURI + 'public/product/promo')
            .then((res) => {
                res.json().then((data) => {
                    this.promotions = data
                });
            })
        },
        getNewProducts() {
            fetch(this.$apiURI + 'public/product/new?limit=12')
            .then((res) => {
                res.json().then((data) => {
                    this.newproducts = data
                });
            })
        },
        getHitProducts() {
            fetch(this.$apiURI + "public/product/hit?limit="+ this.initialLimitPrev +","+ this.initialLimitNext +"")
            .then((res) => {
                res.json().then((data) => {
                    this.hitproducts = data
                    this.loader = false
                });
            })
        },
        initialLimitNextProducts() {
            this.loadProducts = true
            this.initialLimitNext = this.initialLimitNext + 4;
            fetch(this.$apiURI + "public/product/hit?limit="+ this.initialLimitPrev +","+ this.initialLimitNext +"")
            .then((res) => {
                res.json().then((data) => {
                    this.hitproducts = data
                    this.loader = false
                    this.loadProducts = false
                });
            })
        },
        ...mapActions([
          'ADD_TO_CART',
          'ADD_TO_FAVORITE'
        ]),
        addToCart(data){
          this.ADD_TO_CART(data)
        },
        addToFavorite(data){
          this.ADD_TO_FAVORITE(data)
        }
    },
    mounted() {
      this.getPromotions()
      this.getNewProducts()
      this.getHitProducts()
    }
  }
</script>

<style scoped lang="less">
@baseMedia: 900px;

#products {
    width: 100%;
    margin-top: 35px;
    margin-bottom: 35px;
    .products_view_loader {
      width: 100%;
      height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      .loader__color {
        color: #680;
      }
    }
    .products_view_main {
       width: 100%;
      .products__name {
              width: 100%;
              height: 50px;
              position: relative; 
              overflow: hidden;
              .products__name__line {
                  width: 100%;
                  height: 1px;
                  background: #680;
                  margin-top: 26px;
              }
              .products__name__title {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  h2 {
                      background: #fff;
                      display: block;
                      padding: 0 10px;
                      color: #444;
                  }
              }
          }
          .ma-4 {
              margin: 12px;
              width: 250px;
              height: 296px;
          }
          .hit {
            width: 100%;
            .hit__vuew__block {
              width: 100%;
              .hit__vuew__block__margin {
                width: 91%;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                @media (max-width: @baseMedia) {
                    width: 100%;
                    justify-content: center;
                }
                .hit__vuew__block__view {
                    width: 270px;
                    height: 299px;
                    margin-bottom: 10px;
                    @media (max-width: @baseMedia) {
                        height: auto;
                    }
                }
                .load_hit_btn {
                    width: 100%;
                    padding-top: 20px;
                    text-align: center;
                    span {
                      color: #444; 
                      font-size: 20px;
                      font-weight: bold;
                      text-decoration: underline;
                      &:hover {
                        cursor: pointer;
                        color: #000; 
                      }
                    }
                }
              }
            }
          }
    }
    
}
</style>
